import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';
import toNumber from 'lodash-es/toNumber';

/***
 * Класс рейтинга
 * @example
 *
 * Переменные:
 * --percent-color {number, default=0} - процент закрашивания блока жёлтым цветом
 *
 * Аттрибуты на элементах:
 * data-value {number, default = undefined} - значение рейтинга
 */
class StarsRating {
	/***
	 * Конструктор класса
	 * @param elem {HTMLElement} DOM элемент с классом stars-rating
	 * @param force {Boolean|undefined} принудительно инициализирование
	 */
	constructor ({ elem, force }) {
		this.BlockError = new BlockError({ blockName: 'StarsRating', destroy: this.destroy });
		if (!elem) return this.BlockError.error('Отсутствует elem');

		this.block = elem;
		this.block.StarsRating = this;
		this.block.AsyncStarsRating = new Promise((resolve) => {
			this.promiseResolve = resolve;
		}).then((ins) => ins);

		this.LazyInit = new LazyInit({ ins: this, callback: this.init, addClass: 'stars-rating_inited' });
		this.LazyInit.init();
		if (force) this.LazyInit.earlyInit();
	}

	init = async () => {
		this.block.addEventListener('change', this.setRating);

		this.updateRating();

		this.promiseResolve(this);
		this.block.AsyncStarsRating = this;
	};

	setRating = (event) => {
		const dataValue = event.target.value;
		this.block.setAttribute('data-value', dataValue);
		this.setPercentColor(toNumber(dataValue));
	};

	updateRating = () => {
		const dataValue = this.block.dataset['value'];
		if (dataValue) {
			this.setPercentColor(toNumber(dataValue));
		}
	};

	setPercentColor = (value) => {
		//Рейтинг по типу 0.1 плохо видно, он становится 0.18 для расчёта процентов
		const decimal = toNumber((value % 1 * 10).toFixed(2));
		let difference = 0;
		switch(Math.abs(5 - decimal)) {
			case 4:
				difference = 0.08;
				break;
			case 3:
				difference = 0.05;
				break;
			case 2:
				difference = 0.03;
				break;
			default:
				break;
		}
		value += decimal < 5 ? difference : -difference;

		const percentColor = value * 16.667 + 4.167 * Math.floor(value); //16.667% это одна звезда, 4.1667% это один padding
		this.block.style.setProperty('--percent-color', percentColor.toFixed(2));

	};

	destroy = () => {
		if (this.LazyInit) this.LazyInit.destroy();
		if (this.block) {
			this.block.removeEventListener('change', this.setRating);
			this.block.classList.remove('stars-rating_inited');
			delete this.block.StarsRating;
			delete this.block.AsyncStarsRating;
		}
	};

	static init ({ container = document, force = false } = {}) {
		Array.from(container.querySelectorAll('.stars-rating:not(.stars-rating_inited)')).forEach((elem) => new StarsRating({
			elem,
			force
		}));
	}
}

document.addEventListener('DOMContentLoaded', () => StarsRating.init());

// Экспорт;
window.Block.StarsRating = StarsRating;
